<template>
  <div class="intelligentAgriculture-page">
    <!-- 智慧农业 -->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    	<div class="main">
            <div class="top-banner">
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/gongye_oa/banner.png">
                <div class="banner-title">
                    <p style="    text-align: left;
    margin-bottom: 24px;"><span style="    font-size: 64px;
    color: #fff;
    letter-spacing: 18px;">工业</span><span style="    font-size: 64px;
    color: #fff;
    letter-spacing: 8px;">OA</span></p>
                    <p style="
    font-size: 18px;
    text-align: left;
    color: #fff;
    letter-spacing: 6px;">多级分派订单任务，实时跟踪任务进度</P>
                </div>
            </div>
            <div class="mid-body">
                <div class="mid-body-box">
                    <h2 style="text-align: left;margin-bottom: 10px;margin-top: 80px;">Industrial OA</h2>
                    <p style="text-align: left;margin-bottom: 144px;">
                        <span style="font-size: 48px;color: #333;letter-spacing: 18px;">工业</span>
                        <span style="font-size: 48px;color: #333;letter-spacing: 8px;">OA</span>
                    </p>
                    <div>
                        <div class="left-box">
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;">订单任务多级分派</p>
                            <p>业务部门创建公司新订单，将订单拆分给各环节负责人，该负责人将订单任务再次拆分成若干任务并设定时限下发给执行人员，执行人员还可无限拆解任务，将订单任务的各个环节追溯到人。</p>
                        </div>
                        <img style="width:50%;height:auto" src="../../assets/img/caseDetails/gongye_oa/index_01.png">    
                    </div>
                </div>    
            </div>   
            <div class="mid-body">
                <div class="mid-body-box">
                    <div>
                        <div class="left-box">
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;">订单任务实时提醒</p>
                            <p>实时查看目标达成情况数据为优化供应商及员工提供依据</p>
                        </div>
                        <img class="img_index03" src="../../assets/img/caseDetails/gongye_oa/index_03.png">    
                    </div>                     
                </div> 
                <div style="position:relative">
                    <img style="width:100%;height:auto" src="../../assets/img/caseDetails/gongye_oa/index_02.png">    
                    <img class="img_index04" src="../../assets/img/caseDetails/gongye_oa/index_04.png">    
                </div>    
            </div>   
            <div class="mid-body" style="position:relative">
                <div style="position:relative">
                    <img style="width:80%;height:auto;float:right;" src="../../assets/img/caseDetails/gongye_oa/index_05.png">       
                </div> 
                <div class="mid-body-box" style="width: 1000px;position: absolute;top: 21px;left: 24%;">
                    <div>
                        <div class="left-box" >
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;color:#fff">订单任务日程安排</p>
                            <p style="color:#fff">形成每日智能任务清单，手机办公实时提醒，近期日程安排一目了然</p>
                        </div>
                        <img class="img_index06" src="../../assets/img/caseDetails/gongye_oa/index_06.png">    
                        <img class="img_index07" src="../../assets/img/caseDetails/gongye_oa/index_07.png">    
                    </div>                     
                </div> 
                   
            </div>      
             <div class="mid-body" style="position:relative;margin-bottom:0px;margin-top:300px">
                <div style="position:relative">
                    <img style="width:80%;height:auto;float:left;" src="../../assets/img/caseDetails/gongye_oa/index_08.png">       
                </div> 
                <div class="mid-body-box" style="width: 1000px;position: absolute;top: 21px;left: 24%;">
                    <div>
                        <div class="left-box" >
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;color:#fff">实时产能分析</p>
                            <p style="color:#fff">计划产量、已排产量、实际产量
对比统计分析，及时调控，提高
产能效率。</p>
                        </div>
                        <img class="img_index09" src="../../assets/img/caseDetails/gongye_oa/index_09.png">      
                    </div>                     
                </div> 
                   
            </div>     
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style>
    .banner-title{
        width: 490px;
        height: 120px;
        position: absolute;
        top: 50%;
        right: 50%;
        margin-top: 40px;
    }
    .mid-body{
        margin-bottom: 120px;
    }
    .mid-body-box{
        width: 1200px;
        margin: auto;
        position: relative;
    }
    .left-box{
        width: 50%;
        float: left;
        text-align: left;
        box-sizing: border-box;
        padding: 74px;
        font-size: 20px;
        letter-spacing: 4px;
        line-height: 40px;
    }
    .img_index03{
        width:223px;
        height:auto;
        position:absolute;
        right: 405px;
        top: 97px;
        z-index: 2;
    }

    .img_index04{
        width: auto;
        height: 94%;
        position: absolute;
        top: 0;
        right: 65%;
        margin-top: 1%;
    }
        .img_index06{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: 97px;
        z-index: 2;
    }
        .img_index07{
    width: 223px;
    height: auto;
    position: absolute;
    left: 165px;
    top: 229px;
    z-index: 2;
    }
            .img_index09{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: -205px;
        z-index: 2;
    }
</style>